import { JSX } from 'preact'
import classnames from 'classnames'
import { BlockType, TBlockProps } from '@gsc/types'
import { useComponentStyle } from '../Style'
import { Checkbox } from './Checkbox'

export function Flag({ name, value = name, label, required, ...props }: TBlockProps<BlockType.Flag>): JSX.Element {
  const { classes } = useComponentStyle('input-check', props)
  return (
    <div className={classnames('input-flag', classes)}>
      <Checkbox name={name} value={value} label={label} required={required} />
    </div>
  )
}
